'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../../i-bem/i-bem.react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'user-account',
    elem: 'subname',
    tag: 'span',
    content: function content(_ref) {
        var subname = _ref.subname;

        return this.getSubname(subname);
    },
    getSubname: function getSubname(subname) {
        var providers = this.__self.PROVIDERS;

        subname = (typeof subname === 'undefined' ? 'undefined' : _typeof(subname)) === 'object' ? providers[subname.provider] : subname;

        return subname;
    }
}, {
    propTypes: {
        subname: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
    },
    // TODO: https://st.yandex-team.ru/ISL-4238
    PROVIDERS: {
        fb: 'Facebook',
        tw: 'Twitter',
        mr: 'Mail.ru',
        gg: 'Google',
        ok: 'Odnoklassniki',
        vk: 'Vkontakte',
        dz: 'Deezer',
        fs: 'Foursquare',
        ig: 'Instagram',
        lf: 'Last.FM',
        lj: 'LiveJournal',
        'in': 'LinkedIn',
        mt: 'МТС-Россия',
        ms: 'Microsoft',
        yh: 'Yahoo',
        ya: 'Yandex',
        vf: 'Vodafone-Украина',
        tg: 'Telegram'
    }
});